import { Eye } from "lucide-react";
import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuidePreviewProps {
    onClose: () => void;
}

export const HelpGuidePreview = ({ onClose }: HelpGuidePreviewProps) => {
    return (
        <div>
            <ModalHeader
                title="Previewing your Resume"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    To preview your resume, click on the eye icon (
                    <Eye
                        size={16}
                        className="mb-1 inline"
                    />
                    ) at the top of the screen.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The preview modal will appear. You will be able to scroll
                    through each page of your resume. Use the zoom buttons to
                    zoom in and out of the resume.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
